import { render, staticRenderFns } from "./leftMenuSubItem.vue?vue&type=template&id=6275235e&"
import script from "./leftMenuSubItem.vue?vue&type=script&lang=js&"
export * from "./leftMenuSubItem.vue?vue&type=script&lang=js&"
import style0 from "./leftMenuSubItem.vue?vue&type=style&index=0&id=6275235e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports